import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface TenantAdminRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard that requires tenant admin access (role=owner or admin)
 * Platform admins (is_super_admin=true) can also access these routes
 * Redirects to dashboard if user doesn't have admin privileges
 */
export const TenantAdminRoute: React.FC<TenantAdminRouteProps> = ({ children }) => {
  const { user, isAuthenticated } = useAuth();

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  // Check if user is platform admin or tenant admin
  const isPlatformAdmin = user?.is_super_admin === true;
  const isTenantAdmin = user?.role === 'owner' || user?.role === 'admin';

  // Not admin - redirect to dashboard
  if (!isPlatformAdmin && !isTenantAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Admin - allow access
  return <>{children}</>;
};
